import { gql } from "@apollo/client";

export const GET_STRIVE_PIPELINE_V2 = gql`
query strivePipelineV2($params: strivePipelineParams) {
    strivePipelineV2(params: $params) {
        success
        message
        data {
            TOTAL_PROPERTIES
            TOTAL_CLOSED_PROPERTIES
            TOTAL_LIST_PRICE
            TOTAL_NEGOTIATION_PRICE
            TOTAL_CLOSED_PRICE
            TOTAL_FEE_LIST
            TOTAL_STRIVE_FEE
            TOTAL_FEE_NEGOTIATION
            TOTAL_FEE_CLOSED
        }
        error
    }
}
`
export const GET_STRIVE_PIPELINE_V2_SPLIT = gql`
query strivePipelineV2Split($params: strivePipelineParams) {
    strivePipelineV2Split(params: $params) {
        success
        message
        data
        error
    }
}
`

// {
//     buying_closed_split_w_oa
//     buying_split_w_oa
//     listing_closed_split_w_oa
//     listing_split_w_oa
// }

export const GET_STRIVE_PIPELINE_TRANSACTION_TYPE = gql`
query StrivePipelineTransactionType($params: strivePipelineTransactionTypeParams) {
    StrivePipelineTransactionType(params: $params) {
            success
            message
            data {
            TOTAL_PROPERTIES
            TOTAL_CLOSED_PROPERTIES
            TOTAL_LIST_PRICE
            TOTAL_NEGOTIATION_PRICE
            TOTAL_CLOSED_PRICE
            TOTAL_FEE_LIST
            TOTAL_STRIVE_FEE
            TOTAL_FEE_NEGOTIATION
            TOTAL_FEE_CLOSED
            }
            error
    }
}
`

export const GET_STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT = gql`
query StrivePipelineTransactionTypeSplit($params: strivePipelineTransactionTypeParams) {
    StrivePipelineTransactionTypeSplit(params: $params) {
        success
        message
        data
        error
    }
}
`
// buying_closed_split_w_oa
//         buying_split_w_oa
//         listing_closed_split_w_oa
//         listing_split_w_oa
//#region  checked quarterly
export const GET_STRIVE_PIPELINE_CLOSED = gql`
query strivePipelineClosed($transactionYear: Int!) {
    strivePipelineClosed(TRANSACTION_YEAR: $transactionYear) 
}
`
// {
//     total_closed_price
//     total_closed_properties
//     total_fee_closed
// }
export const GET_STRIVE_PIPELINE_CLOSED_SPLIT = gql`
query strivePipelineClosedSplit($transactionYear: Int!) {
    strivePipelineClosedSplit(TRANSACTION_YEAR: $transactionYear)
}
`

export const GET_STRIVE_QUARTERLY_PIPELINE = gql`
query striveQuarterlyPipeline($quarterStart: String!, $quarterEnd: String!) {
    striveQuarterlyPipeline(QUARTER_START: $quarterStart, QUARTER_END: $quarterEnd) 
}
`
// {
//     total_industrial_gross_fee
//     total_industrial_mt_gross_fee
//     total_industrial_mt_price
//     total_industrial_mt_properties
//     total_industrial_price
//     total_industrial_properties
//     total_industrial_stnl_gross_fee
//     total_industrial_stnl_price
//     total_industrial_stnl_properties
//     total_office_gross_fee
//     total_office_mt_gross_fee
//     total_office_mt_price
//     total_office_mt_properties
//     total_office_price
//     total_office_properties
//     total_office_stnl_gross_fee
//     total_office_stnl_price
//     total_office_stnl_properties
//     total_other_gross_fee
//     total_other_mt_gross_fee
//     total_other_mt_price
//     total_other_mt_properties
//     total_other_price
//     total_other_properties
//     total_other_stnl_gross_fee
//     total_other_stnl_price
//     total_other_stnl_properties
//     total_quarter_gross_fee
//     total_quarter_price
//     total_quarter_properties
//     total_retail_gross_fee
//     total_retail_mt_gross_fee
//     total_retail_mt_price
//     total_retail_mt_properties
//     total_retail_price
//     total_retail_properties
//     total_retail_stnl_gross_fee
//     total_retail_stnl_price
//     total_retail_stnl_properties

// }

export const GET_STRIVE_QUARTERLY_PIPELINE_SPLIT = gql`
query striveQuarterlyPipelineSplit($quarterStart: String!, $quarterEnd: String!) {
    striveQuarterlyPipelineSplit(QUARTER_START: $quarterStart, QUARTER_END: $quarterEnd) 
}
`
// {
//     buy_industrial_mt_split
//     buy_industrial_split
//     buy_industrial_stnl_split
//     buy_office_mt_split
//     buy_office_split
//     buy_office_stnl_split
//     buy_other_mt_split
//     buy_other_split
//     buy_other_stnl_split
//     buy_quarter_split
//     buy_retail_mt_split
//     buy_retail_split
//     buy_retail_stnl_split
//     list_industrial_mt_split
//     list_industrial_split
//     list_industrial_stnl_split
//     list_office_mt_split
//     list_office_split
//     list_office_stnl_split
//     list_other_mt_split
//     list_other_split
//     list_other_stnl_split
//     list_quarter_split
//     list_retail_mt_split
//     list_retail_split
//     list_retail_stnl_split
// }

//#endregion

//#region Year change
export const GET_STRIVE_HISTORICAL_PIPELINE= gql`
query striveHistoricalPipeline($transactionYear: Int!) {
    striveHistoricalPipeline(TRANSACTION_YEAR: $transactionYear) 
}
`
// {
//     total_closed_price
//     total_closed_properties
//     total_fee_closed
//     total_industrial_gross_fee
//     total_industrial_mt_gross_fee
//     total_industrial_mt_price
//     total_industrial_mt_properties
//     total_industrial_price
//     total_industrial_properties
//     total_industrial_stnl_gross_fee
//     total_industrial_stnl_price
//     total_industrial_stnl_properties
//     total_office_gross_fee
//     total_office_mt_gross_fee
//     total_office_mt_price
//     total_office_mt_properties
//     total_office_price
//     total_office_properties
//     total_office_stnl_gross_fee
//     total_office_stnl_price
//     total_office_stnl_properties
//     total_other_gross_fee
//     total_other_mt_gross_fee
//     total_other_mt_price
//     total_other_mt_properties
//     total_other_price
//     total_other_properties
//     total_other_stnl_gross_fee
//     total_other_stnl_price
//     total_other_stnl_properties
//     total_retail_gross_fee
//     total_retail_mt_gross_fee
//     total_retail_mt_price
//     total_retail_mt_properties
//     total_retail_price
//     total_retail_properties
//     total_retail_stnl_gross_fee
//     total_retail_stnl_price
//     total_retail_stnl_properties

// }

export const GET_STRIVE_HISTORICAL_PIPELINE_SPLIT= gql`
query striveHistoricalPipelineSplit($transactionYear: Int!) {
    striveHistoricalPipelineSplit(TRANSACTION_YEAR: $transactionYear) 
}
`

// {
//     buying_closed_split_w_oa
//     buy_industrial_mt_split
//     buy_industrial_stnl_split
//     buy_office_mt_split
//     buy_office_stnl_split
//     buy_other_mt_split
//     buy_other_stnl_split
//     buy_retail_mt_split
//     buy_retail_stnl_split
//     buy_total_industrial_split
//     buy_total_office_split
//     buy_total_other_split
//     buy_total_retail_split
//     listing_closed_split_w_oa
//     list_industrial_mt_split
//     list_industrial_stnl_split
//     list_office_mt_split
//     list_office_stnl_split
//     list_other_mt_split
//     list_other_stnl_split
//     list_retail_mt_split
//     list_retail_stnl_split
//     list_total_industrial_split
//     list_total_office_split
//     list_total_other_split
//     list_total_retail_split
// }

//#endregion

//#region click on status columns

export const GET_STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE = gql`
query getStrivePipelineByStatusAndTransactionType($pageOptions: PageOptions) {
    getStrivePipelineByStatusAndTransactionType(pageOptions: $pageOptions) {
        active_gross_fee
        address
        arcimedes_row_id
        buying_closed_split_w_oa
        buying_split_w_oa
        city
        closed_gross_fee
        close_of_escrow
        is_other
        listed_date
        listing_closed_split_w_oa
        listing_split_w_oa
        list_price
        name
        negotiation_gross_fee
        negotiation_price
        potential_fee
        referral_fee
        sold_price
        state
        status
    }
}
`


export const  STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE_QUERY = gql`
query strivePipelineByStatusAndTransactionType($params: strivePipelineTransactionTypeParams) {
  strivePipelineByStatusAndTransactionType(params: $params)
}
`


//#endregion